import { FunctionComponent } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from '@/lib';
import { CreateTransactionModalFormModel } from '../CreateTransactionModal/CreateTransactionModalFormModel';
import { useTransactionContext } from '../../context/TransactionContext';
import { GenericSelect } from '@/components/inputs/GenericSelect';

interface TransactionFromLocationFieldProps {
  control: Control<CreateTransactionModalFormModel>;
  errors: FieldErrors<CreateTransactionModalFormModel>;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const TransactionFromLocationField: FunctionComponent<TransactionFromLocationFieldProps> = ({
  control,
  errors,
  disabled,
  autoFocus,
}) => {
  const { t } = useTranslation();
  const { getAvailableLocationsFor } = useTransactionContext();
  const availableLocations = getAvailableLocationsFor('from');

  return (
    <Controller
      name="fromLocationId"
      control={control}
      rules={{ required: true }}
      render={({ field }) => (
        <GenericSelect
          label={t('from_location')}
          value={field.value}
          options={availableLocations}
          onChange={(value) => field.onChange(value)}
          error={errors.fromLocationId !== undefined}
          helperText={errors.fromLocationId?.message}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      )}
    />
  );
};
